import React from "react";
import {Grid, MenuItem, Select} from "@mui/material";
import {Controller, useFormContext} from "react-hook-form";

interface MWSelectBoxProps<T> {
  name: string;
  label: string;
  data: T[];
}

const MWClientSelectBox = <T extends {value: number; label: string}>({
  name,
  label,
  data,
}: MWSelectBoxProps<T>) => {
  const {control} = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({field}) => (
        <Grid container alignItems="center" justifyContent="flex-start">
          <Grid
            item
            xs={0}
            sm={0}
            md={3}
            lg={3}
            xl={3}
            sx={{display: {xs: "none", sm: "none", md: "block"}}}
          >
            <label htmlFor={name}>{label} : </label>
          </Grid>
          <Grid item xs={12} sm={12} md={5} lg={5} xl={5}>
            <Select
              {...field}
              id={name}
              label={label}
              size="small"
              defaultValue={field.value}
              style={{width: "100%"}}
            >
              <MenuItem disabled value={field.value} style={{display: "none"}}></MenuItem>

              {data.map(
                (item) =>
                  item.value > -1 && (
                    <MenuItem key={item.value} value={item.value}>
                      {item.label}
                    </MenuItem>
                  )
              )}
            </Select>
          </Grid>
        </Grid>
      )}
    />
  );
};

export default MWClientSelectBox;
